/**
 * Path segments and route names for the public organization area (mounted under
 * `join/:identifier/...` in `routes.js`).
 *
 * Define each path **once** here and reference the constant from both the route definition and any
 * link builder (`urlUtil.getLocalisedOrganizationUrl(org, OrganizationPath.MEMBERSHIPS)`), instead
 * of repeating the raw string. A path lives in the layer that best describes it — routing — so it
 * can be renamed in one place and grep finds every use.
 *
 * Related: registration-result sub-paths live next to the booking-status domain they belong to
 * (`RegistrationPath` in `src/js/constants/participantBookingStatus.js`). Other org sub-paths
 * (`class/:class`, `cancel-event/...`, `login`) can migrate here as they need to be referenced
 * from link builders.
 */
/** The segment every studio page is mounted under: `/join/:identifier/...`. */
export const ORGANIZATION_ROOT_SEGMENT = 'join'

export const OrganizationPath = {
  MEMBERSHIPS: 'memberships',
  CLASS: 'class',
  /**
   * The studio's public contact page: how to reach them, plus the company details identifying who the
   * customer is contracting with when the studio publishes those. Linked from the payment view, the
   * organization footer and the consent row at signup. Reachable company details are a MakeCommerce
   * condition; the page is useful to every studio regardless.
   */
  CONTACTS: 'contacts',
  /** Participant account signup. Mounted both at the site root and under the organization page. */
  SIGNUP_PARTICIPANT: 'signup-participant'
}

export const OrganizationRouteName = {
  MEMBERSHIPS: 'organization-memberships',
  CONTACTS: 'organization-contacts',
  SIGNUP_PARTICIPANT: 'organization-signup-participant'
}
